"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "randomInt", {
    enumerable: true,
    get: function() {
        return randomInt;
    }
});
function randomInt(min = 0, max = 10) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
